import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FiArrowUpRight, FiLinkedin, FiMail } from 'react-icons/fi';
import { SITE_METADATA } from '../utils/constants';

const Contact = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <section className="section-padding bg-white">
      <motion.div
        ref={ref}
        initial={{ opacity: 0, y: 24 }}
        animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 24 }}
        transition={{ duration: 0.6 }}
        className="container-custom"
      >
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-sm uppercase tracking-[0.2em] text-gold font-semibold mb-3">Connect</p>
          <h2 className="text-4xl md:text-5xl font-serif text-navy mb-5">Let&apos;s connect.</h2>
          <p className="text-lg text-charcoal leading-relaxed max-w-2xl mx-auto mb-9">
            I&apos;m always interested in thoughtful conversations around AI, PropTech, real estate innovation, partnerships and the future of technology-driven sales.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href={SITE_METADATA.linkedIn}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary inline-flex items-center justify-center gap-2"
            >
              <FiLinkedin /> Connect on LinkedIn <FiArrowUpRight />
            </a>
            <a
              href={`mailto:${SITE_METADATA.email}`}
              className="btn-secondary inline-flex items-center justify-center gap-2"
            >
              <FiMail /> {SITE_METADATA.email}
            </a>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default Contact;
